import React, { useRef, useState } from "react";
import { Container, Grid, useTheme } from "@mui/material";

import { P, SectionHeading, SectionSmallHeading, SectionSubHeading, SectionWrapper } from "../../Styles/style";


import tokenimage from "../../../assets/images/tokenimage.png"
import { MainGrid} from "./styles";
import styled from "@emotion/styled";
const MainWrapper = styled.div`
display:flex;
align-items: center;
min-height: 100vh;
padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  text-align: ${(props) => (props.align ? props.align : "center")};

  @media screen and (max-width: 799px) {
    padding: ${(props) => (props.p799 ? props.p799 : "")};
  }
  @media screen and (max-width: 599px) {
    padding: ${(props) => (props.p599 ? props.p599 : "30px 0")};
  }
`

const BuyNow = styled.a`
text-decoration: none;
background-color: ${(props) => (props.bgColor ? props.bgColor : props.theme.textTertiary)};
color: ${(props) => (props.Color ? props.Color : props.theme.textPrimary)};
padding: 8px 50px;
border-radius: 5px;
margin-right: 15px;

`

const Img = styled.img`
  /* width:100%;
  max-width: 50px; */
`
const Tokenimg = styled.img`
  width:100%;
  max-width: 850px;
  height:auto;

`
const GridsWrap = styled(Grid)`

`
const Containers = styled(Container)`
  position: relative;
`
const Index = () => {
  const theme = useTheme()
  

  return (
    <MainWrapper p="4rem 0" align="left" id="tokenomics" >
      <Container maxWidth="xl">
        <SectionHeading fs="60px" p="20px 0px" m="0" data-aos="flip-down"
          data-aos-easing="ease-in"
          data-aos-delay="500"
          data-aos-duration="700"
          align="center"
          data-aos-offset="0">TOKENOMICS</SectionHeading>
        <MainGrid container spacing={0}>
          <GridsWrap item xs={12} md={6} data-aos="fade-up"
            data-aos-anchor-placement="top-bottom" data-aos-delay="600"
            data-aos-duration="1000">
            <SectionSubHeading p=" 30px 0 0">
              Total supply
            </SectionSubHeading>
            <SectionSmallHeading p="0px 0" m="0" maxWidth="70%" fs600px="14px">1,000,000,000</SectionSmallHeading>

            <SectionSubHeading p=" 30px 0 0">
              Name
            </SectionSubHeading>
            <SectionSmallHeading p="0px 0" m="0" maxWidth="70%" fs600px="14px">Pepedoge</SectionSmallHeading>

            <SectionSubHeading p=" 30px 0 0">
              Symbol
            </SectionSubHeading>
            <SectionSmallHeading p="0px 0" m="0" maxWidth="70%" fs600px="14px">$PEGE</SectionSmallHeading>

            <SectionSubHeading p=" 30px 0 0" id="Contract">
              Contract
            </SectionSubHeading>
            <SectionSmallHeading fs="28px" p="0px 0" m="0" maxWidth="70%" fs600px="14px" >0xf994cab2f787159725372004142a685ea9576824</SectionSmallHeading>

          </GridsWrap>
          <Grid item xs={12} md={6} data-aos="flip-down"
            data-aos-easing="ease-in"
            data-aos-delay="500"
            data-aos-duration="700"
            data-aos-offset="0">
            <Tokenimg src={tokenimage} />

          </Grid>
        </MainGrid>
      </Container>
    </MainWrapper>
  );
};

export default Index;
